import { Directive, ElementRef, AfterViewInit } from '@angular/core'

@Directive({
  selector: '[focusInput]',
})
export class FocusInputDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      const inputElement = this.el.nativeElement.querySelector('input, textarea')
      if (inputElement) {
        inputElement.focus()
      }
    }, 0)
  }
}
